<template>
  <v-container style="background-color: white" fluid>
    <v-expand-transition>
      <v-card flat v-show="!show_new_moduls" height="75vh">
        <v-row no-gutters class="pb-0 mb-0" justify="center">
          <v-col cols="12" md="6" justify="center" align="center">
            <span style="font-size: 30px; color: #616161">
              <v-icon large class="pr-1 pb-2">view_module</v-icon>
              Modulos</span
            >
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="3">
            <v-autocomplete
              v-model="calendar_selected"
              @change="get_accounting_module_details()"
              :items="calendars"
              item-text="name"
              item-value="id"
              return-object
              label="Calendarios"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="business_selected"
              :items="calendar_business"
              item-text="description_long"
              item-value="id"
              label="Unidad de negocio"
              color="cyanText"
              prepend-inner-icon="corporate_fare"
              outlined
              @change="get_accounting_module_details()"
              dense
              return-object
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" align="center">
            <v-btn outlined color="success" @click="generate_new_modules()"
              >Generar modulos</v-btn
            >
          </v-col>
        </v-row>
        <v-divider class="mb-4"></v-divider>
        <v-row no-gutters justify="center" v-show="items.length == 0">
          <v-col cols="12" md="6" justify="center" align="center">
            <span style="font-size: 25px; color: #616161"
              >ESTA UNIDAD DE NEGOCIOS NO TIENE MODULOS REGISTRADOS EN ESTE
              CALENDARIO</span
            >
          </v-col>
        </v-row>
        <v-treeview
          return-object
          class="mt-5"
          activatable
          open-all
          :items="items"
          v-if="items.length > 0"
        >
          <template slot="label" slot-scope="{ item }">
            <span class="primary--text font-weight-bold"
              >{{ item.code }} -</span
            >
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:prepend>
            <v-icon color="success">vertical_split</v-icon>
          </template>
          <template slot="append" slot-scope="{ item }">
            <div class="d-flex align-center">
              <v-autocomplete
                v-model="item.from_calendar_period_id"
                :items="periods_limit(item,'start')"
                item-text="period_name"
                item-value="accounting_period_id"
                label="Periodo inicial"
                color="cyanText"
                required
                dense
                @change="change_limits(item)"
                hide-details
                style="width: 300px"
              ></v-autocomplete>
              <v-divider vertical class="mx-2"></v-divider>
              <v-autocomplete
                v-model="item.to_calendar_period_id"
                :items="periods_limit(item,'end').filter((element) =>element.accounting_period_id >=item.from_calendar_period_id)"
                item-text="period_name"
                item-value="accounting_period_id"
                label="Periodo final"
                color="cyanText"
                required
                style="width: 300px"
                dense
                @change="pending_uptades = true,change_limits(item)"
                hide-details
              ></v-autocomplete>
            </div>
          </template>
        </v-treeview>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="success"
            v-show="pending_uptades"
            @click="update_modules"
            :loading="loading_update"
            >Actualizar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-expand-transition>
    <v-expand-transition>
      <v-card flat v-if="show_new_moduls">
        <v-row align="center" class="pa-5">
          <v-btn
            small
            dense
            outlined
            color="error"
            @click="show_new_moduls = false"
            >Volver</v-btn
          >
          <v-spacer></v-spacer>
          <span style="font-size: 20px; color: #616161">
            Generar modulos para el calendario
            {{ calendar_selected.name }}</span
          >
          <v-spacer></v-spacer>
          <v-btn
            small
            dense
            outlined
            color="success"
            @click="save_accounting_modules()"
            :loading="loading"
            >Guardar</v-btn
          >
        </v-row>
        <v-card outlined class="mt-2">
          <v-container>
            <div
              v-for="item in new_accounting_modules"
              :key="item.module_type_id"
            >
              <v-row align="center" class="py-2">
                <v-col cols="12" md="4">
                  <span>{{ item.name }}</span>
                </v-col>
                <v-col cols="12" md="4" justify="end">
                  <v-autocomplete
                    v-model="item.start_period_id"
                    :items="periods_formate_start"
                    item-text="period_name"
                    item-value="accounting_period_id"
                    label="Periodo inicial"
                    color="cyanText"
                    outlined
                    required
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" justify="end">
                  <v-autocomplete
                    v-model="item.end_period_id"
                    :items="
                      periods_formate_end.filter(
                        (element) =>
                          element.accounting_period_id >= item.start_period_id
                      )
                    "
                    item-text="period_name"
                    item-value="accounting_period_id"
                    label="Periodo final"
                    color="cyanText"
                    outlined
                    required
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <v-row no-gutters class="mt-5" justify="center">
              <v-col cols="12" md="6" justify="center" align="center">
                <span style="font-size: 15px; color: #616161">
                  Indique las unidades a las que se les aplicará!</span
                >
              </v-col>
            </v-row>
            <v-row jutify="center" class="mt-5">
              <v-col cols="12" md="12">
                <DataIterator
                  :all_items="calendar_business"
                  :items_selected="business_selected_for_data_iterator"
                  :title="setTitle"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-card>
    </v-expand-transition>
  </v-container>
</template>
<script>
import moment from "moment";
import DataIterator from "@/components/base/DataIterator";
export default {
  data: () => ({
    calendar_selected: null,
    business_selected: null,
    show_new_moduls: false,
    loading: false,
    loading_update: false,
    pending_uptades: false,
    bussines_units: [],
    business_selected_for_data_iterator: [],
    new_accounting_modules: [],
    setTitle: {
      all: "Unidades",
      selected: "Seleccionadas",
    },
    items: [],
    items_periods: [],
    module_types: [],
    calendars: [],
  }),
  components: {
    DataIterator,
  },
  // created() {},
  mounted() {
    this.initialized();
  },
  computed: {
    calendar_business() {
      let business = [];
      if (
        this.calendar_selected == null ||
        this.calendar_selected.business_units.length == 0
      ) {
        return business;
      }
      for (let item of this.calendar_selected.business_units) {
        let bu = this.bussines_units.find(
          (element) => element.id === item.business_unit_id
        );
        if (bu) {
          business.push(bu);
        }
      }
      this.business_selected = business[0];
      return business;
    },
    periods_formate_start() {
      moment.locale("es");
      let periods = [];
     // let calendars_open = this.calendars.filter((element) => element.is_closed == false);
      let calendars_open =  this.calendars
      for (let calendar of calendars_open) {
        let busine = calendar.business_units.find((element) => element.business_unit_id === this.business_selected.id);
        // El cierre es POR UNIDAD DE NEGOCIO: filtrar por el flag de la unidad
        // (busine.is_closed), no por el flag global del calendario. Así, cerrar
        // una unidad no bloquea a las demás. Debe ser consistente con periods_formate_end.
        if (busine == undefined || busine.is_closed == true) {
          continue;
        }

        for (let item of calendar.periods) {
          periods.push({
            accounting_calendar_id: item.accounting_calendar_id,
            accounting_period_id: item.id,
            period_name: `${item.period_name} (${moment(item.date_from).format(
              "DD MMMM YYYY"
            )})`,
            date_from: item.date_from,
            date_to: item.date_to,
          });
        }
      }
      return periods;
    },
    periods_formate_end() {
      moment.locale("es");
      let periods = [];
      //revisar
     // let calendars_open = this.calendars.filter((element) => element.is_closed == false);
      let calendars_open = this.calendars;
      for (let calendar of calendars_open) {
        let busine = calendar.business_units.find(
          (element) => element.business_unit_id === this.business_selected.id
        );
        if (busine == undefined || busine.is_closed == true) {
          continue;
        }
        for (let item of calendar.periods) {
          periods.push({
            accounting_calendar_id: item.accounting_calendar_id,
            accounting_period_id: item.id,
            period_name: `${item.period_name} (${moment(item.date_to).format(
              "DD MMMM YYYY"
            )})`,
            date_from: item.date_from,
            date_to: item.date_to,
          });
        }
      }
      // for(let item of this.calendar_selected.periods){
      //   periods.push({
      //         accounting_calendar_id: item.accounting_calendar_id,
      //         accounting_period_id: item.accounting_period_id,
      //         period_name: `${item.period_name} (${moment(item.date_to).format('DD MMMM')})`,
      //         date_from: item.date_from,
      //         date_to: item.date_to
      //     })
      // }
      return periods;
    },
  },
  // watch: {},
  methods: {
    async initialized() {
      this.get_calendars();
      this.bussines_units = await this.g_bussines();
      for (let key in this.bussines_units) {
        this.bussines_units[key].name =
          this.bussines_units[key].description_long;
      }
      await this.get_module_types();
      this.get_accounting_module_details();
    },
    async get_module_types() {
      const modules = await this.api_Get("accounting/get_module_types");
      const data = await modules.json();
      this.module_types = data;
      for (let item of data) {
        this.new_accounting_modules.push({
          module_type_id: item.id,
          name: item.name,
          parent_id: item.parent_id,
          start_period_id: null,
          end_period_id: null,
        });
      }
    },
    async get_calendars() {
      const calendars = await this.api_Get("accounting/get_calendars");
      this.calendars = await calendars.json();
      this.calendar_selected = this.calendars[0];
    },
    build_tree(data) {
      function buildTree(data, parent, parentID = null) {
        const tree = [];
        data.forEach((item) => {
          if (item.parent_id === parentID) {
            const children = buildTree(data,item,item.accounting_module_type_id);
            if (children.length) {
              item.children = children;
            }
            item.from_limit = parent.name ? parent.from_calendar_period_id : item.from_calendar_period_id;
            item.to_limit = parent.name ? parent.to_calendar_period_id : item.to_calendar_period_id;
            tree.push(item);
          }
        });
        return tree;
      }
      return buildTree(data[0].periods_detail, data[0], null);
    },
    flat_tenTree(tree) {
      function flattenTree(tree, parent = null) {
        let flattened = [];
        tree.forEach((node) => {
          const copy = { ...node, parent_id: parent };
          delete copy.children;
          flattened.push(copy);
          if (node.children) {
            flattened = flattened.concat(
              flattenTree(node.children, node.accounting_module_type_id)
            );
          }
        });
        return flattened;
      }
      return flattenTree(tree);
    },
    async get_accounting_module_details() {
      try {
        const periods = await this.api_Post(
          "accounting/accounting_module_details",
          {
            accounting_calendar_id: this.calendar_selected.id,
            business_unit_id: this.business_selected.id,
          }
        );
        const data = await periods.json();

        if (data.length == 0) {
          this.items = [];
          return;
        }
        const treeData = this.build_tree(data);
        this.items = treeData;
      } catch (error) {
        console.error(error.message);
      }
    },
    generate_new_modules() {
      this.show_new_moduls = true;
    },
    async save_accounting_modules() {
      if (this.business_selected_for_data_iterator.length == 0) {
        this.$toast.warning("Debe escoger al menos una unidad de negocios!");
        return;
      }
      try {
        this.loading = true;
        let business = [];
        for (let item of this.business_selected_for_data_iterator) {
          business.push({
            calendar_id: this.calendar_selected.id,
            business_unit_id: item,
          });
        }
        const response = await this.api_Post(
          "accounting/save_accounting_modules",
          { business: business, modules: this.new_accounting_modules }
        );
        if (response.status == 200) {
          this.$toast.success("Modulos registrados correctamente!");
          this.get_accounting_module_details();
          this.show_new_moduls = false;
          this.loading = false;
          return;
        }
        this.$toast.error("Error al intentar generar los modulos!");
      } catch (error) {
        console.error(error.message);
      }
      this.loading = false;
    },
    async update_modules() {
      try {
        this.loading_update = true;
        const flatData = this.flat_tenTree(this.items);

        const response = await this.api_Put("accounting/update_module_period", {
          modules: flatData,
        });
        if (response.status == 200) {
          this.$toast.success("Modulos actualizados correctamente!");
          this.loading_update = false;
          return;
        }
        this.$toast.error("Error al actualizar los modulos!");
      } catch (error) {
        console.error(error.message);
      }
      this.loading_update = false;
    },
    periods_limit(module,origin) {
      let periods_to_process=origin=='start' ? this.periods_formate_start : this.periods_formate_end;
      if (module.parent_id == null) {
        return periods_to_process;
      }
   
      const periods = periods_to_process.filter((element) =>element.accounting_period_id >= module.from_limit && element.accounting_period_id <= module.to_limit);
      return periods;
    },

    change_limits(module) {
    // Función recursiva para actualizar los límites de los hijos
    const updateChildrenLimits = (parentModule) => {
      if (!parentModule.children) return;

      parentModule.children.forEach(childModule => {
        // El módulo hijo no puede exceder los límites del padre
        childModule.from_limit = parentModule.from_calendar_period_id;
        childModule.to_limit = parentModule.to_calendar_period_id;

        // Ajustar los valores actuales si están fuera de los límites
        if (childModule.from_calendar_period_id < childModule.from_limit) {
          childModule.from_calendar_period_id = childModule.from_limit;
        }
        if (childModule.to_calendar_period_id > childModule.to_limit) {
          childModule.to_calendar_period_id = childModule.to_limit;
        }

        // Asegurar que los límites de los hijos también se actualicen recursivamente
        updateChildrenLimits(childModule);
      });
    };

    // Aplicar los límites a los hijos del módulo actual
    updateChildrenLimits(module);

    // Marcar que hay actualizaciones pendientes para guardar
    this.pending_uptades = true;
  }
  },
};
</script>
